import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-17a6 6 0 1 0 2.675 11.372.691.691 0 0 0 .175-.09.513.513 0 0 0 .16-.382.5.5 0 0 0-.5-.5.506.506 0 0 0-.24.056A5 5 0 1 1 17 12h-1.644c-.283 0-.37.18-.21.401L17.07 15.1c.153.213.416.221.574 0l1.926-2.698c.153-.213.064-.401-.21-.401H18a6 6 0 0 0-6-6z"
});

var SvgReorderFilled = function SvgReorderFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgReorderFilled;